// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1CTzX","Ready":"Header_Ready__3pNTp","Title":"Header_Title__f9_xb","Logo":"Header_Logo__3cTtT"};